module.exports = __webpack_public_path__ + "static/img/legend_xg.380871c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg.png
// module id = 9yJL
// module chunks = 94